export default __webpack_public_path__ + "static/media/screen_35.a366a86a.png";